
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {pull, remove} from "lodash";
import {ProductInfo} from "@/model/HqPackingListModels";
import CustomsPackingInfoInTable from "@/views/components/CustomsPackingInfoInTable.vue";
import {CustomsPackingModel, LoadingInfo, PackingVolume, ProductInfoModel} from "@/model/HenganLoadingPlanModels";
import {ContainerTypeModel} from "@/model/ContainerType";
import {Message} from "element-ui";
import {deepClone} from "@/utils/deepClone";
import Template from "@/views/system-management/template/index.vue";

/*配置柜型*/
@Component({
  name: "ConfigContainerTypeComponent",
  components: {Template, CustomsPackingInfoInTable },
  methods: {
    pull, remove
  }
})

export default class extends Vue {

  @Prop({ required: true }) private data: ContainerTypeConfigurationInfo;
  @Prop({ required: true }) private list: LoadingInfo[] = [];
  @Prop({ required: false, default: true }) private editable: boolean;
  @Prop({ required: false, default: false }) private withTotalAmount: boolean;
  private headerInfo: HeaderInfo = new HeaderInfo(null, null, null, null, null);
  private loadingInfos: LoadingInfo[] = [];
  private unloadedCustomsPackingInfos: CustomsPackingModel[] = [];
  private pendingWarehouseInCustomsPackingInfos: CustomsPackingModel[] = [];
  private problemCustomsPackingInfos: CustomsPackingModel[] = [];
  private noPackingInfoCustomsPackingInfos: CustomsPackingModel[] = [];
  private noLoadedCustomsPackingInfos: CustomsPackingModel[] = [];
  private unpackedProductInfos: ProductInfo[] = [];
  private unloadedContainerTypeInfos: string[] = [];
  private availableContainerTypes: ContainerTypeModel[] = [];
  private currentSelectContainerTypeId: string = null;
  private selectedCustomsPackingSet1: CustomsPackingInfo[] = [];
  private selectedCustomsPackingSet2: CustomsPackingInfo[] = [];
  private createDeliveryList = false;

  @Watch("data", { deep: true, immediate: true })
  private convertData() {
    this.headerInfo = new HeaderInfo(this.data.id, this.data.code, this.data.customerAbbreviation, this.data.customerCode, this.data.billOfLadingCode);
    // this.loadingInfos = [...this.data.loadingInfos];
    this.unpackedProductInfos = [...this.data.unpackedProductInfos];
    this.availableContainerTypes = [...this.data.containerTypes];
    this.unloadedContainerTypeInfos = [...this.data.unloadedContainerTypeInfos];
    this.unloadedCustomsPackingInfos = [...this.data.alreadyGoodsCustomsPackingSet];
    this.pendingWarehouseInCustomsPackingInfos = [...this.data.pendingScanCustomsPackingSet];
    this.noPackingInfoCustomsPackingInfos = [...this.data.unpackedCustomsPacking];
    this.problemCustomsPackingInfos = [...this.data.problemCustomsPackingSet];
    this.noLoadedCustomsPackingInfos = [...this.data.noLoadedCustomsPackingSet];
  }
  @Watch("list", { deep: true, immediate: true })
  private watchList() {
    this.loadingInfos = deepClone(this.list);
  }

  private calculateVolume(packingVolume: PackingVolume) {
    return new PackingVolume(packingVolume.length, packingVolume.width, packingVolume.height).calculateVolumeNoDecimalProcessing();
  }

  private addLoadingInfo() {
    const loadingInfo: LoadingInfo = new LoadingInfo();
    loadingInfo.customsPackingSet = [];
    this.loadingInfos.push(loadingInfo);
  }

  private removeLoadingInfo(index: number) {
    const loadingInfo: LoadingInfo = this.loadingInfos.filter((_, idx) => idx === index)[0];
    if (loadingInfo.id) {
      this.$emit("delete-loading-info", loadingInfo.id);
    } else {
      loadingInfo.customsPackingSet?.forEach(value => this.unbindCustomsPacking(loadingInfo, value.id));
      this.availableContainerTypes.forEach(value => {
        if (value.id === loadingInfo.containerType?.id) {
          value.disabled = false;
        }
      });
      this.loadingInfos = this.loadingInfos.filter((_, idx) => idx !== index);
    }
  }

  private async createLoadingInfo() {
    this.$emit("save-loading-infos", this.createDeliveryList, this.loadingInfos);
  }

  private titleOfSaveLoadingInfo() {
    var cps = this.unboxingCustomsPacking().map(cp => cp.code).map(code => `${code.typeCode}${code.selfCode}#${code.serialNumber}`);
    var res = "";
    if (cps.length > 0) {
      res += "请注意: " + cps.join(",") + "没有按照销售员指令拆托/箱。"
    }
    return res;
  }

  // 未拆托/箱的主包装
  private unboxingCustomsPacking() {
    return this.loadingInfos.flatMap(info => info.customsPackingSet).filter(cp => cp.unboxing);
  }

  private onSelectionChange(rows: CustomsPackingInfo[]) {
    this.selectedCustomsPackingSet1 = rows;
  }

  private onSelectionChange2(rows: CustomsPackingInfo[]) {
    this.selectedCustomsPackingSet2 = rows
  }

  private onContainerTypeSelectChange(item: LoadingInfo) {
    item.containerNumber = item.containerType.containerNumber;
    item.sealNumber = item.containerType.sealNumber;
    item.weight = item.containerType.weight;
    // 释放旧的
    const old: ContainerTypeModel = this.availableContainerTypes.filter(value => item.containerTypeId === value.id)[0];
    if (old) {
      old.disabled = false;
    }
    // 绑定新的
    this.availableContainerTypes.filter(value => item.containerType.id === value.id)[0].disabled = true;
    item.containerTypeId = item.containerType.id;
  }

  private bindCustomsPacking() {
    const selectLoadingInfos: LoadingInfo[] = this.loadingInfos.filter(value =>
        (value.containerType?.id && value.containerType.id === this.currentSelectContainerTypeId) ||
        value.containerTypeId === this.currentSelectContainerTypeId);
    if (selectLoadingInfos.length < 1) {
      Message.error({
        message: "当前柜型没有装柜信息",
        duration: 2000
      });
      return;
    }
    const ids: string[] = this.selectedCustomsPackingSet1.concat(this.selectedCustomsPackingSet2).map(value => value.id);
    if (ids.length < 1) {
      Message.error({
        message: "请选择主包装",
        duration: 2000
      });
      return;
    }
    selectLoadingInfos[0].customsPackingSet.push(...this.unloadedCustomsPackingInfos.filter(value => ids.includes(value.id))
      .concat(this.pendingWarehouseInCustomsPackingInfos.filter(value => ids.includes(value.id))));
    this.unloadedCustomsPackingInfos = this.unloadedCustomsPackingInfos.filter(value => !ids.includes(value.id));
    this.pendingWarehouseInCustomsPackingInfos = this.pendingWarehouseInCustomsPackingInfos.filter(value => !ids.includes(value.id));
  }

  private unbindCustomsPacking(loadingInfo: LoadingInfo, customsPackingId: string) {
    let customsPackingSet = loadingInfo.customsPackingSet;
    loadingInfo.customsPackingSet = loadingInfo.customsPackingSet.filter(value => value.id !== customsPackingId);
    let exists = customsPackingSet.filter(value => value.id === customsPackingId);
    if (exists[0].state.desc === "已备货") {
      this.unloadedCustomsPackingInfos.push(exists[0]);
    } else {
      this.pendingWarehouseInCustomsPackingInfos.push(exists[0]);
    }
  }

  private allUnBindCustomsPacking(loadingInfo: LoadingInfo, row){
    let customsPackingSet = loadingInfo.customsPackingSet;
    let ids: string[] = [row.id];
    row.children.forEach(value => {
      ids.push(value.id);
    });
    loadingInfo.customsPackingSet = loadingInfo.customsPackingSet.filter(value => !ids.includes(value.id))
    let exists = customsPackingSet.filter(value => ids.includes(value.id));
    exists.forEach(value => {
      if(value.state.desc === "已备货") {
        this.unloadedCustomsPackingInfos.push(value);
      }else {
        this.pendingWarehouseInCustomsPackingInfos.push(value);
      }
    })
  }

  private calculateTotalAmount(customsPackingSet: CustomsPackingModel[]): string {
    return customsPackingSet.map(c => c.secondaryPackingSet)
      .reduce((pre, cur) => pre.concat(cur), [])
      .map(s => s.packingInfos)
      .reduce((pre, cur) => pre.concat(cur), [])
      .map(info => info.productInfos)
      .reduce((pre, cur) => pre.concat(cur), [])
      .map(p => p.totalNumberPcs * p.unitPrice)
      .reduce((pre, cur) => pre + Number(cur), 0)
      .toFixed(2);
  }
}


export class ContainerTypeConfigurationInfo {
  id: string;
  code: string;
  customerId: string;
  customerCode: string;
  customerAbbreviation: string;
  billOfLadingCode: string;
  unloadedContainerTypeInfos: string[] = [];
  containerTypes: ContainerTypeModel[] = [];
  unpackedCustomsPacking: CustomsPackingModel[] = [];
  pendingScanCustomsPackingSet: CustomsPackingModel[] = [];
  problemCustomsPackingSet: CustomsPackingModel[] = [];
  alreadyGoodsCustomsPackingSet: CustomsPackingModel[] = [];
  noLoadedCustomsPackingSet: CustomsPackingModel[] = [];
  unpackedProductInfos: ProductInfoModel[] = [];
  loadingInfos: LoadingInfo[] = [];
}

class HeaderInfo {
  id: string;
  code: string;
  customerAbbreviation: string;
  customerCode: string;
  billOfLadingCode: string;


  constructor(id: string, code: string, customerAbbreviation: string, customerCode: string, billOfLadingCode: string) {
    this.id = id;
    this.code = code;
    this.customerAbbreviation = customerAbbreviation;
    this.customerCode = customerCode;
    this.billOfLadingCode = billOfLadingCode;
  }
}


/**
 * 主包装信息
 */
class CustomsPackingInfo {
  id: string;
  code: string;
  loadingInfoId: string;
  problemType: string;
}

